import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Lock, Sparkles } from "lucide-react";
import API_BASE_URL from "../config";
import "./UnlockModal.css";

const TELEGRAM_PURCHASE_URL = "https://t.me/solidityset/1556";

export const UnlockModal = ({ isOpen, onClose, lessonTitle, moduleNumber }) => {
  const [substat, setSubstat] = useState(0);

  useEffect(() => {
    if (!isOpen) return;

    const fetchSubstat = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/auth/me`, {
          credentials: "include",
        });

        if (response.ok) {
          const data = await response.json();
          const next = data.substat || 0;
          setSubstat(next);
          if (next === 9) {
            onClose();
          }
        }
      } catch (err) {
        console.error("Ошибка получения информации о пользователе:", err);
        setSubstat(0);
      }
    };

    fetchSubstat();
  }, [isOpen, onClose]);

  if (substat === 9) {
    return null;
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="unlock-modal">
        <DialogHeader>
          <div className="unlock-modal-header">
            <div className="unlock-modal-icon-wrapper">
              <Lock className="unlock-modal-icon" />
            </div>
            <DialogTitle className="unlock-modal-title">
              Разблокировать доступ к проекту
            </DialogTitle>
          </div>
          <DialogDescription className="unlock-modal-description">
            <div>
              <p className="unlock-lesson-text">
                Этот урок является частью премиум-контента. Полный доступ открывает
                все модули самоучителя: продвинутые темы, практические задания и
                примеры смарт-контрактов.
              </p>
            </div>

            <div className="unlock-features">
              <div className="unlock-feature">
                <Sparkles className="unlock-feature-icon" />
                <p className="unlock-feature-text">Практические задания и реальные проекты</p>
              </div>
              <div className="unlock-feature">
                <Sparkles className="unlock-feature-icon" />
                <p className="unlock-feature-text">Профессиональные инструменты и стандарты</p>
              </div>
              <div className="unlock-feature">
                <Sparkles className="unlock-feature-icon" />
                <p className="unlock-feature-text">Тестирование, безопасность и оптимизация</p>
              </div>
            </div>

            <div className="unlock-modules-list">
              <p className="unlock-modules-title">Полный доступ к самоучителю</p>
              <div className="unlock-module-item">
                <div className="unlock-module-info">
                  <span className="unlock-module-name">Все модули и материалы</span>
                  <div className="unlock-module-price">
                    <span className="unlock-price-amount">75 USDT</span>
                    <span className="unlock-price-separator">или</span>
                    <span className="unlock-price-amount">6000 ₽</span>
                  </div>
                </div>
                <Button asChild className="unlock-btn-module">
                  <a
                    href={TELEGRAM_PURCHASE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Купить доступ
                  </a>
                </Button>
                <p className="unlock-lesson-text unlock-messenger-hint">
                  После нажатия на кнопку вы перейдёте в Telegram канал.
                </p>
              </div>
            </div>
          </DialogDescription>
        </DialogHeader>

        <DialogFooter className="unlock-modal-footer">
          <Button variant="ghost" onClick={onClose} className="unlock-btn-cancel">
            Отмена
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
